// Cloudinary upload helper
// Uses unsigned upload preset — no secret key needed on the frontend

const CLOUD_NAME = 'diylvbjam'
const UPLOAD_PRESET = 'humanorigin' // you will create this in Cloudinary dashboard

export async function uploadToCloudinary(file, folder = 'general') {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('upload_preset', UPLOAD_PRESET)
  formData.append('folder', folder)

  const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
    method: 'POST',
    body: formData,
  })

  if (!res.ok) {
    const err = await res.json()
    throw new Error(err.error?.message || 'Cloudinary upload failed')
  }

  const data = await res.json()
  return data.secure_url // the public URL of the uploaded image
}
